import { useState, useEffect } from 'react';

/**
 * A hook to determine if a "New" badge should be displayed based on a go-live date and duration.
 * @param {string} goLiveDateStr - The go-live date as a string in 'YYYY-MM-DD' format.
 * @param {number} durationInWeeks - The duration for which the badge should be displayed, in weeks. Defaults to 6 weeks.
 * @returns {boolean} - Returns true if the badge should be displayed, false otherwise.
 */
export const useNewBadge = (goLiveDateStr, durationInWeeks = 6) => {
  const [showBadge, setShowBadge] = useState(false);

  useEffect(() => {
    const goLiveDate = new Date(goLiveDateStr);
    const durationInMs = durationInWeeks * 7 * 24 * 60 * 60 * 1000;
    setShowBadge(new Date().getTime() - goLiveDate.getTime() < durationInMs);
  }, [goLiveDateStr, durationInWeeks]);

  return showBadge;
};
